import type { ValidationError } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import { bankAccountSchema } from '../../model/schemas';

export function validateBankDetails(
  value: unknown,
  shouldSkipEmpty = true
): ValidationError[] {
  if (!value && shouldSkipEmpty) return [];
  const result = bankAccountSchema.safeParse(value);
  if (result.success) return [];
  return zodIssuesToValidationErrors(result.error.issues);
}
